import { ShipmentSapDeliveryListSearchCriteria } from '../../../../../common/models';

export class ShipmentWaybillSapDeliveriesLoad {
  public static readonly type = '[ShipmentWaybillSapDeliveries] Load';
  constructor(public payload: ShipmentSapDeliveryListSearchCriteria) {}
}

export class ShipmentWaybillSapDeliveriesInitialState {
  public static readonly type = '[ShipmentWaybillSapDeliveries] Set Initial State';
}
